import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/customer-dashboard/addresses/page.tsx");
